/** BENQI sAVAX (Lido-clone) — `getPooledAvaxByShares(uint256)`
 *  returns the AVAX equivalent of a given share amount; pass `1e18`
 *  to get the 1e18-scaled rate. `totalPooledAvax()` returns total
 *  AVAX held (used as `totalAssets`). */
export const BenqiSavaxAbi = [
  {
    name: 'getPooledAvaxByShares',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'shareAmount' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'totalPooledAvax',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
